// Local Functions
const sendEventToGA = (buttonName, action = 'CTA Click', category = 'Magazine') =>
  globalThis.ga?.('send', 'event', category, action, buttonName);

// Module Exports
export { sendEventToGA };
